import { addLeadingZeros } from '@elliemae/ds-utilities/timeUtils';
import { parseInt, isNaN } from '@elliemae/ds-utilities/utils';

const AM = 'am';
const PM = 'pm';
const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
const BACKSPACE = 'Backspace';
const ESCAPE = 'Escape';
const HOME = 'Home';
const SHIFT = 'Shift';
const END = 'End';
const HOUR_RANGE_12 = { min: 0, max: 12 };
const HOUR_RANGE_24 = { min: 0, max: 24 };
const GENERAL_TIME_RANGE = { min: 0, max: 59 };
const PLACEHOLDER_TIME = {
  hour: 'hour',
  minutes: 'minutes',
  seconds: 'seconds',
  meridiem: 'meridiem',
};

var isAM = function isAM(time) {
  return time && time.hour() < 12;
};

var isArrowIncrementDecrement = function isArrowIncrementDecrement(key) {
  return key === ARROW_DOWN || key === ARROW_UP || key === SHIFT;
};
var setNativeValue = function setNativeValue(element, value) {
  if (!Object.getOwnPropertyDescriptor(element, 'value')) return;
  var valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
  var prototype = Object.getPrototypeOf(element);
  var prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

  if (valueSetter && valueSetter !== prototypeValueSetter) {
    prototypeValueSetter.call(element, value);
  } else {
    valueSetter.call(element, value);
  }

  element.dispatchEvent(new Event('input', {
    bubbles: true
  }));
};
var placeholderFormat = function placeholderFormat(position, format, use12Hours) {
  if (position === PLACEHOLDER_TIME.hour) {
    return _placeholderHour(format, use12Hours);
  }

  if (position === PLACEHOLDER_TIME.minutes) {
    return format.indexOf('mm') > -1 ? 'mm' : 'm';
  }

  if (position === PLACEHOLDER_TIME.seconds) {
    return format.indexOf('ss') > -1 ? 'ss' : 's';
  }

  if (position === PLACEHOLDER_TIME.meridiem) {
    return format.indexOf('A') > -1 ? 'A' : 'a';
  }
};

var _placeholderHour = function _placeholderHour(format, use12Hours) {
  if (use12Hours) {
    return format.indexOf('hh') > -1 ? 'hh' : 'h';
  }

  return format.indexOf('HH') > -1 ? 'HH' : 'H';
};

var formatTimeNumber = function formatTimeNumber(value, shouldAddLeadingZeros) {
  if (value === null || value === undefined) return '';
  return shouldAddLeadingZeros ? addLeadingZeros(2)(value) : String(value);
};

var formatMinutes = function formatMinutes(format, value) {
  var shouldAddLeadingZeros = format.indexOf('mm') > -1;
  return formatTimeNumber(value, shouldAddLeadingZeros);
};
var formatSeconds = function formatSeconds(format, value) {
  var shouldAddLeadingZeros = format.indexOf('ss') > -1;
  return formatTimeNumber(value, shouldAddLeadingZeros);
};
var formatHour = function formatHour(format, value) {
  var shouldAddLeadingZeros = format.indexOf('HH') > -1 || format.indexOf('hh') > -1;
  return formatTimeNumber(value, shouldAddLeadingZeros);
};
var formatMeridiem = function formatMeridiem(format, value) {
  return format.indexOf('A') > -1 ? value.toUpperCase() : value.toLowerCase();
};
var parseTimeNumberFromText = function parseTimeNumberFromText(stringValue) {
  var parsedInt = parseInt(stringValue);
  if (isNaN(parsedInt)) return null;
  return parsedInt;
};
var focusNextInput = function focusNextInput(currentEl) {
  var nextElement = currentEl.nextElementSibling;

  if (nextElement && nextElement.nextElementSibling) {
    nextElement.nextElementSibling.focus();
  }
};
var focusPreviousInput = function focusPreviousInput(currentEl) {
  var previousElement = currentEl.previousElementSibling;

  if (previousElement && previousElement.previousElementSibling) {
    previousElement.previousElementSibling.focus();
  }
};
var getValidTimeNumber = function getValidTimeNumber(_ref, number, typed) {
  var min = _ref.min,
      max = _ref.max;
  if (number === undefined || number === null) return null;

  if (number > max) {
    if (isNaN(typed)) return parseInt(typed);
    return max;
  }

  if (number < min) return min;
  return number;
};
var shouldFocusNextInput = function shouldFocusNextInput(max) {
  var number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var stringValue = arguments.length > 2 ? arguments[2] : undefined;
  var safeString = String(stringValue);
  var cleanString = safeString.startsWith('00') ? safeString.slice(1) : safeString;
  return number * 10 > max || String(max).length === cleanString.length;
};
var getTimeValuesFromTime = function getTimeValuesFromTime(time, format, use12Hours) {
  if (!time || !time.hour) return {};
  var hours = use12Hours ? time.hour() % 12 || 12 : time.hour();
  var minutes = time.minutes();
  var seconds = time.seconds();
  var meridiem = !isAM(time) ? PM : AM;
  return {
    hours: formatHour(format, hours),
    minutes: formatMinutes(format, minutes),
    seconds: formatSeconds(format, seconds),
    meridiem: meridiem
  };
};
var resetTimeValues = function resetTimeValues() {
  return {
    hours: '',
    minutes: '',
    seconds: '',
    meridiem: AM
  };
};
var commonInputProps = function commonInputProps(onKeyDown, onInputFocus, onClick) {
  return {
    pattern: '[0-9]*',
    type: 'text',
    onKeyDown: onKeyDown,
    onClick: onClick,
    onFocus: onInputFocus
  };
};

export { AM as A, BACKSPACE as B, END as E, GENERAL_TIME_RANGE as G, HOME as H, PLACEHOLDER_TIME as P, SHIFT as S, ARROW_UP as a, ARROW_DOWN as b, commonInputProps as c, PM as d, focusNextInput as e, formatMeridiem as f, getTimeValuesFromTime as g, ESCAPE as h, focusPreviousInput as i, parseTimeNumberFromText as j, getValidTimeNumber as k, formatSeconds as l, formatMinutes as m, formatHour as n, shouldFocusNextInput as o, placeholderFormat as p, isArrowIncrementDecrement as q, HOUR_RANGE_12 as r, setNativeValue as s, HOUR_RANGE_24 as t, resetTimeValues as u };
//# sourceMappingURL=utils-0a7eb302.js.map
